import { useRef, useState } from 'react';
import { Form } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import CalendarInput from '@/component/CalendarInput';

const ReleaseSchedule = ({ releaseDate, onReleaseDateChange, newYorkMidnight }) => {
	const [releaseImmediately, setReleaseImmediately] = useState(false);

	// Stores the last date the user picked (manual input only)
	const lastManualDateRef = useRef(null);

	const handleManualDateChange = date => {
		lastManualDateRef.current = date; // track user input
		onReleaseDateChange(date);
	};

	const handleToggle = e => {
		const checked = e.target.checked;

		if (checked) {
			// Before overwriting, remember current value (if any) as the "manual" value
			if (releaseDate) lastManualDateRef.current = releaseDate;

			const nyMidnight = newYorkMidnight();
			const oneDayBefore = new Date(nyMidnight);
			oneDayBefore.setDate(oneDayBefore.getDate() - 1);

			onReleaseDateChange(oneDayBefore);
			setReleaseImmediately(true);
		} else {
			// Restore user's last picked date, if none, default to NY midnight (today)
			onReleaseDateChange(lastManualDateRef.current ?? newYorkMidnight());
			setReleaseImmediately(false);
		}
	};

	return (
		<>
			<Form.Check
				type="switch"
				id="release-immediately"
				label="Release Immediately"
				checked={releaseImmediately}
				onChange={handleToggle}
				style={{ marginBottom: '1rem' }}
			/>

			{!releaseImmediately && (
				<div style={{ display: 'flex', gap: '3rem', width: '100%' }}>
					<Form.Group controlId="description" style={{ width: '100%', marginTop: '1rem' }}>
						<Form.Label>Release Date</Form.Label>

						<div style={{ position: 'relative', width: '100%', height: '100%', zIndex: 1000 }}>
							<DatePicker
								selected={releaseDate || newYorkMidnight()}
								onChange={handleManualDateChange}
								minDate={newYorkMidnight()}
								dateFormat="MMMM d, yyyy"
								customInput={<CalendarInput />}
							/>
						</div>
					</Form.Group>
				</div>
			)}
		</>
	);
};

export default ReleaseSchedule;
